module.exports = __webpack_public_path__ + "TB_Eating_SFX_B.wav.07b93529.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/eating/TB_Eating_SFX_B.wav.mp3
// module id = 495
// module chunks = 0